import React from "react";
import { Link } from "react-router-dom";
import { Brand } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-40 bg-slate-50/90 backdrop-blur border-b">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center"><Brand /></div>
      </header>
      <div className="max-w-md mx-auto px-6 pt-24 text-center" data-testid="payment-cancel-page">
        <h1 className="font-heading text-3xl font-extrabold text-midnight">Checkout cancelled</h1>
        <p className="text-ink-secondary mt-3">No worries — you weren't charged. You can pick a plan whenever you're ready.</p>
        <Link to="/pricing"><Button className="mt-8" data-testid="payment-cancel-pricing"><ArrowLeft size={15} className="mr-1" /> Back to pricing</Button></Link>
      </div>
    </div>
  );
}
